export const project = [
  {
    title: "Ajio.com",
    tech_stack: "<\\> Html | Css | JS",
    description:
      "AJIO is Reliance Retail digital commerce initiative. We have created the clone of Ajio.com with all it's main functions like- login & signup, search, sort, add product to cart, buy product etc.",
    image:
      "https://github.com/vshubhams/Ajio-clone/raw/master/screenshots/Screenshot%20(65).png",
    github: "https://github.com/vshubhams/Ajio-clone",
    live: "https://www.ajioproject.ml/",
  },
  {
    title: "Milaap.org",
    tech_stack: "<\\> React | Jason server | JS | Html | Css",
    description:
      "This is a working clone of online crowdfunding website MILAAP. This is a collaborative project under the guidance of MASAI Team to facilitate the full stack web development curriculam.",
    image:
      "https://user-images.githubusercontent.com/83001524/129575962-3a15bfe4-4f33-484a-b842-82e97fc44599.png",
    github: "https://github.com/bharadwaj-bhat/Project_milaap",
    live: "https://bharadwaj-bhat.github.io/Project_milaap/#/",
  },
  {
    title: "Travelocity.com",
    tech_stack: "<\\> React | Jason server | JS | Html | Css",
    description:
      "This is the clone of the Travelocity website. Travelocity is an online travel agency. From this website, users can book a hotel room, flights, cars, etc. across the world.",
    image:
      "https://github.com/sheikhtausif/travelocity-clone/raw/master/Screenshots/Home1.png",
    github: "https://github.com/sheikhtausif/travelocity-clone",
    live: "https://travelocity-clone.vercel.app/",
  },
];
